export default {
  baseUrl: {
        dev: "http://yjsgk.top:26160/", // 开发环境由http://yjsgk.top:2615/js2020/替换
        test: "http://yjsgk.top:26170/",
        cms: "http://yjsgk.top:4000/"
  },
};